
export default {
  props: {
    data: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  computed: {
    fullSizeImageCssClass() {
      return [
        this.$backgroundClassPicker(this.data.backgroundColor),
        this.$route.fullPath.includes('news') ? 'border-0' : ''
      ].filter((c) => !!c);
    }
  }
};
